import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { setStateValue } from '../../../../../../actions/actionsModuloRelatorio';
import { NotificationMessage } from '../../../../../../components';
import * as service from '../../services';

export const useRemoveReportItem = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  const successAction = () => {
    NotificationMessage('success', 5000, 'Relatório removido com sucesso.');
    dispatch(setStateValue('showModalDeleteSavedReport', false));
    queryClient.invalidateQueries(['get-saved-report-table']);
  };

  const removeReport = useMutation({
    mutationFn: id => service.deleteSavedReportItemService(id),
    onSuccess: successAction,
  });

  return {
    handleRemoveReport: removeReport.mutate,
  };
};
